module.exports = __webpack_public_path__ + "static/media/LogotipoNSA.06ae2651.png";